module.exports = __webpack_public_path__ + "static/img/1-0.d5b92ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/1-0.jpg
// module id = QF3B
// module chunks = 1